import { ChangeDetectionStrategy, Component, Input, OnDestroy, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { Subject } from 'rxjs';
import { PhxCollapseItemComponent } from './collapse-item/phx-collapse-item.component';
import { PhxCollapseType, PHX_COLLAPSE_TYPE } from './phx-collapse.types';

@Component({
  selector: 'phx-collapse',
  template: `<ng-content></ng-content>`,
  styleUrls: ['./phx-collapse.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  host: {
    class: 'phx-collapse',
    '[class.phx-collapse-default]': 'phxType === PHX_COLLAPSE_TYPE.DEFAULT',
    '[class.phx-collapse-caption]': 'phxType === PHX_COLLAPSE_TYPE.CAPTION',
    '[class.phx-collapse-title]': 'phxType === PHX_COLLAPSE_TYPE.TITLE',
    '[class.phx-collapse-fit-width]': 'phxFitWidth',
  },
})
export class PhxCollapseComponent implements OnDestroy {
  @Input() phxAccordion: boolean = false;
  @Input() phxType: PhxCollapseType = PHX_COLLAPSE_TYPE.DEFAULT;
  @Input() phxFitWidth: boolean = false;
  @Input() phxCompact: boolean = false;

  public readonly PHX_COLLAPSE_TYPE = PHX_COLLAPSE_TYPE;
  private _listOfPhxCollapseItemComponent: PhxCollapseItemComponent[] = [];
  private _destroy$: Subject<void> = new Subject<void>();

  ngOnChanges(changes: SimpleChanges): void {
    const { phxType, phxCompact } = changes;

    if (phxType || phxCompact) {
      this._listOfPhxCollapseItemComponent.forEach((item) => item.markForCheck());
    }
  }

  public ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  public addItem(value: PhxCollapseItemComponent): void {
    this._listOfPhxCollapseItemComponent.push(value);
  }

  public removeItem(value: PhxCollapseItemComponent): void {
    this._listOfPhxCollapseItemComponent.splice(this._listOfPhxCollapseItemComponent.indexOf(value), 1);
  }

  public click(collapse: PhxCollapseItemComponent): void {
    if (this.phxAccordion && !collapse.phxActive) {
      this._listOfPhxCollapseItemComponent
        .filter((item) => item !== collapse)
        .forEach((item) => {
          if (item.phxActive) {
            item.phxActive = false;
            item.phxActiveChange.emit(item.phxActive);
            item.markForCheck();
          }
        });
    }
    collapse.phxActive = !collapse.phxActive;
    collapse.phxActiveChange.emit(collapse.phxActive);
  }
}
